export default "__VITE_ASSET__DDIGbVfd__"